import { render, staticRenderFns } from "./ClassRegisterMore.vue?vue&type=template&id=4ed42ea2&scoped=true&"
import script from "./ClassRegisterMore.vue?vue&type=script&lang=js&"
export * from "./ClassRegisterMore.vue?vue&type=script&lang=js&"
import style0 from "./ClassRegisterMore.vue?vue&type=style&index=0&id=4ed42ea2&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed42ea2",
  null
  
)

export default component.exports